'use client';

import Link from '@/components/TopLink';
import { useLang } from '@/i18n/client';
import { Icon } from './Icons';

const COPY = {
  en: 'Start my 60 days',
  de: 'Meine 60 Tage starten',
  fr: 'Commencer mes 60 jours',
};
const MALE_COPY = {
  en: 'Start my beard routine',
  de: 'Meine Bartpflege starten',
  fr: 'Commencer ma routine barbe',
};

export function OfferJump() {
  const lang = useLang();
  return (
    <div className="offer-jump">
      <Link className="btn btn--lg btn--cta" href="#product-offer" data-track="return-to-offer">
        <span className="aud-f">{COPY[lang]}</span><span className="aud-m">{MALE_COPY[lang]}</span> <Icon name="arrow" />
      </Link>
    </div>
  );
}
